import React from 'react';
import { InviteNonUserForm } from 'modules/components/layer12';
import { BasicFormModalLayout } from 'modules/components/layer13';
import { useParams } from 'react-router-dom';

export type InviteNonUserModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

export const FC = (props: InviteNonUserModalProps) => {
  const params = useParams();
  return (
    <BasicFormModalLayout.FC
      id={props.id}
      title='Add Team Member'
      subTitle='Add a member to the project that can not access the system.'
      handleClose={props.handleClose}
      isVisible={props.isVisible}
    >
      <InviteNonUserForm.FC
        projectId={params.projectId ?? ''}
        handleClose={props.handleClose}
      />
    </BasicFormModalLayout.FC>
  );

};
